export default __webpack_public_path__ + "static/media/151-advert.89db6847.png";